// Patient overview section questionnaire linkIds
export enum PatientOverviewQuestionnaireItem {
  // Demographics
  PATIENT_OVERVIEW_DEMOGRAPHICS_LEGAL_NAME = 'patient-overview/demographics/legal-name',
  PATIENT_OVERVIEW_DEMOGRAPHICS_PREFERRED_NAME = 'patient-overview/demographics/preferred-name',
  PATIENT_OVERVIEW_DEMOGRAPHICS_DATE_OF_BIRTH = 'patient-overview/demographics/date-of-birth',
  PATIENT_OVERVIEW_DEMOGRAPHICS_ADDRESS = 'patient-overview/demographics/address',
  PATIENT_OVERVIEW_DEMOGRAPHICS_GENDER = 'patient-overview/demographics/gender',
  PATIENT_OVERVIEW_DEMOGRAPHICS_SEX = 'patient-overview/demographics/sex',
  PATIENT_OVERVIEW_DEMOGRAPHICS_MEDICAID_ID = 'patient-overview/demographics/medicaid-id',
  PATIENT_OVERVIEW_DEMOGRAPHICS_SSN = 'patient-overview/demographics/ssn',
  PATIENT_OVERVIEW_DEMOGRAPHICS_PRIMARY_LANGUAGE = 'patient-overview/demographics/primary-language',
  PATIENT_OVERVIEW_DEMOGRAPHICS_RELIGION = 'patient-overview/demographics/religion',
  PATIENT_OVERVIEW_DEMOGRAPHICS_RACE = 'patient-overview/demographics/race',

  // Care Team
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN = 'patient-overview/care-team/legal-guardian',
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_NAME = 'patient-overview/care-team/legal-guardian/name',
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_RELATION_TO_PATIENT = 'patient-overview/care-team/legal-guardian/relation-to-patient',
  PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER = 'patient-overview/care-team/caregiver',
  PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER_NAME = 'patient-overview/care-team/caregiver/caregiver-name',
  PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER_RELATION_TO_PATIENT = 'patient-overview/care-team/caregiver/relation-to-patient',
  PATIENT_OVERVIEW_CARE_TEAM_ORDERING_PRACTITIONER = 'patient-overview/care-team/ordering-practitioner',
  PATIENT_OVERVIEW_CARE_TEAM_PRIMARY_CARE_PROVIDER = 'patient-overview/care-team/primary-care-provider',
  PATIENT_OVERVIEW_CARE_TEAM_ORDER_PREFERENCE = 'patient-overview/care-team/order-preference',
  PATIENT_OVERVIEW_CARE_TEAM_SOC_DATE = 'patient-overview/care-team/soc-date',
  PATIENT_OVERVIEW_CARE_TEAM_F2F_DATE = 'patient-overview/care-team/f2f-date',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT = 'patient-overview/care-team/emergency-contact',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_NAME = 'patient-overview/care-team/emergency-contact/name',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_PHONE = 'patient-overview/care-team/emergency-contact/phone',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_ADDRESS = 'patient-overview/care-team/emergency-contact/address',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER = 'patient-overview/care-team/alternate-caregiver',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_NAME = 'patient-overview/care-team/alternate-caregiver/name',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_PHONE = 'patient-overview/care-team/alternate-caregiver/phone',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_ADDRESS = 'patient-overview/care-team/alternate-caregiver/address'
}
